// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
// import Mint from 'mint-ui'
// import './assets/main.scss'
import Vant from 'vant';
import 'vant/lib/index.css';
var SocialSharing = require('vue-social-sharing');

Vue.config.productionTip = false

// Vue.use(Mint)
Vue.use(Vant)
Vue.use(Utils)
Vue.use(SocialSharing)

import Utils from './utils'
window.Utils = Utils

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

Vue.mixin({
    methods: {
        $messagebox_lang(opt){
            if(typeof opt == 'object'){
                return this.$dialog.alert({...opt, confirmButtonText:'ok'})
            }else{
                return this.$dialog.alert({title:'', message:opt, confirmButtonText:'ok'})
            }
        },
        langMsg(obj, key){
            return obj[`${key}_${this.lang}`] || obj[key];
        }
    }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js